import { ComposeWidget } from "../widgets/ComposeWidget";
import { Mode } from "../widgets/ComposeWidget";

export const ComposePage = () => {
  return (
    <div>
      <h1>Compose</h1>
      <ComposeWidget mode={Mode.Compose} />
    </div>
  );
};
